import { render } from "./TheL01NewsList.vue?vue&type=template&id=24fc99c8&scoped=true&ts=true"
import script from "./TheL01NewsList.vue?vue&type=script&lang=ts"
export * from "./TheL01NewsList.vue?vue&type=script&lang=ts"

import "./TheL01NewsList.vue?vue&type=style&index=0&id=24fc99c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fc99c8"]])

export default __exports__